<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Disciplinary Documents"
      text="Upload Disciplinary Documents"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col cols="12">
            <helper-file-input
              v-model="file" 
              v-validate="'required'"
              :max-size-in-mb="10"
              :max-number="5"
              :multiple="true"
              data-vv-name="files"
              field-name="files"
              accept-type=".pdf"    
              extension="ext:pdf"         
            >
              <div 
                slot="activator"
                class="mb-2"
              >   
                <v-btn                    
                  :disabled="progressing"
                  class="mx-2"    
                >
                  Add file
                </v-btn>
                <span> 
                  {{ file ? '' : 'No file chosen (.pdf only)' }}
                </span>
                <div
                  v-if="file"
                  class="mt-4"
                >
                  <p
                    v-for="selectedFile in file.selectedFiles"
                    :key="selectedFile.name"
                    class="mb-0"
                  >
                    <span class="font-weight-bold">{{ selectedFile.name }}</span>
                  </p>
                </div>
              </div>
            </helper-file-input>
            <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String, 
        required: true,
      },
    },
    data () {
      return {
        disciplinaryCaseId: null,
        progressing: false,
        dialog: false,
        file: null,
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },
    methods: {
      toggleDialog (disciplinaryCase) {
        this.disciplinaryCaseId = disciplinaryCase.id

        this.dialog = true
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true

            this.$api.employeeDisciplineCases().upload(this.disciplinaryCaseId, this.file.formData)
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('uploaded')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(error => {
                if (error.response.status === 405) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })      
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
